import { CreateUserBulkInput, User } from '@/models/gen/graphql';

import { CreateUserDocument } from '@/api/queries';
import { Dayts } from '@/utils';
import graphApi from '@/api';

const [runCreateUser] = graphApi(CreateUserDocument);

export type CreateUserPayload = Partial<User> & { password: string };

const createUser = async (payload: CreateUserPayload) => {
  const input: CreateUserBulkInput = {
    values: [
      {
        active: payload.active ? 1 : 0,
        address: payload.address || null,
        avatar: payload.avatar || null,
        cityName: payload.cityName || null,
        companyId: payload.companyId,
        countryCode: payload.countryCode || null,
        dob: payload.dob ? new Dayts(payload.dob).format() : null,
        email: payload.email,
        employeeId: payload.employeeId || null,
        firstName: payload.firstName,
        lastName: payload.lastName,
        longTrip: payload.longTrip ? 1 : 0,
        notes: payload.notes || null,
        password: payload.password,
        phone: payload.phone ? payload.phone.replace(/\D/g, '') : null,
        primaryAirportCode: payload.primaryAirportCode || null,
        providerId: payload.providerId || null,
        roleId: payload.roleId,
        startDate: payload.startDate ? new Dayts(payload.startDate).format() : null,
        stateCode: payload.stateCode || null,
        username: payload.username,
        zipCode: payload.zipCode || null,
      },
    ],
  };

  const res = await runCreateUser({ input });
  return res;
};

export default createUser;
